import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Search } from "lucide-react";

export default function EntityFiltersBar({
  filters,
  setFilters,
  managers,
  activeFilterCount,
  onReset,
}) {
  return (
    <div
      className="border border-line bg-card p-4 grid grid-cols-1 md:grid-cols-4 gap-3"
      data-testid="entity-filters"
    >
      <div className="md:col-span-1">
        <Label className="eyebrow">Search</Label>
        <div className="relative mt-1">
          <Search className="w-3.5 h-3.5 absolute left-2 top-1/2 -translate-y-1/2 text-ink-2" />
          <Input
            className="rounded-sm pl-7"
            placeholder="Name, email, phone, GSTIN"
            value={filters.q}
            onChange={(e) => setFilters({ ...filters, q: e.target.value })}
            data-testid="entity-filter-search"
          />
        </div>
      </div>
      <div>
        <Label className="eyebrow">Account Manager</Label>
        <Select
          value={filters.account_manager_id}
          onValueChange={(v) => setFilters({ ...filters, account_manager_id: v })}
        >
          <SelectTrigger className="rounded-sm mt-1" data-testid="entity-filter-am">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All managers</SelectItem>
            <SelectItem value="none">Unassigned</SelectItem>
            {managers.map((m) => (
              <SelectItem key={m.id} value={m.id}>{m.name}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label className="eyebrow">Outstanding</Label>
        <Select
          value={filters.outstanding}
          onValueChange={(v) => setFilters({ ...filters, outstanding: v })}
        >
          <SelectTrigger className="rounded-sm mt-1" data-testid="entity-filter-outstanding">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All</SelectItem>
            <SelectItem value="has">Has outstanding</SelectItem>
            <SelectItem value="paid">All paid up</SelectItem>
            <SelectItem value="none">No invoices yet</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label className="eyebrow">Reliability</Label>
        <Select
          value={filters.reliability}
          onValueChange={(v) => setFilters({ ...filters, reliability: v })}
        >
          <SelectTrigger className="rounded-sm mt-1" data-testid="entity-filter-reliability">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All</SelectItem>
            <SelectItem value="on_time">On time (≥85%)</SelectItem>
            <SelectItem value="slipping">Sometimes late (60-84%)</SelectItem>
            <SelectItem value="late">Frequent late (&lt;60%)</SelectItem>
            <SelectItem value="none">No history</SelectItem>
          </SelectContent>
        </Select>
      </div>
      {activeFilterCount > 0 && (
        <div className="md:col-span-4 flex items-center gap-2 pt-1">
          <span className="text-[11px] text-ink-2">
            {activeFilterCount} filter{activeFilterCount === 1 ? "" : "s"} active
          </span>
          <Button
            size="sm"
            variant="ghost"
            onClick={onReset}
            className="rounded-sm h-6 px-2 text-xs"
            data-testid="entity-filter-reset"
          >
            Clear filters
          </Button>
        </div>
      )}
    </div>
  );
}
